/* * 公告下发组件 * 描述：包括表单、企业树和文本编辑框 * 创建时间：2017-03-28 * 创建人：Shujuan Sun * 修改时间： * 修改人： */
<template>
	<div class="wrapper-content fadeInRight animated tabBox" id="notice-release">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<!--表单部分开始-->
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">标题</label>
					<div class="col-sm-11">
						<input type="text" class="form-control" v-model.trim="noticeInfo.title" maxlength="50">
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">时间</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" readonly :value="curDate">
					</div>
					<label class="col-sm-1 control-label">来源</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" readonly :value="noticeInfo.source==0?'系统公告':'企业公告'">
					</div>
					<label class="col-sm-1 control-label">重要度</label>
					<div class="col-sm-1">
						<select class="form-control" v-model="noticeInfo.status">
							<option v-for="option in statusList" v-bind:value="option.udccode">
								{{ option.udcname }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<!--表单部分结束-->
			<div class="row">
				<!--企业树部分开始-->
				<div class="col-sm-3">
					<div class="ibox-content">
						<div class="form-group">
							<label class="col-sm-12  control-label t_left">公告范围</label>
						</div>
						<div class="form-group">
							<div class="radio radio-success radio-inline">
								<input type="radio" id="alarmPlan1" value=1 name="radioInline" v-model="noticeInfo.recordType">
								<label for="alarmPlan1">本企业及所有下属企业</label>
							</div>
						</div>
						<div class="form-group">
							<div class="radio radio-success radio-inline">
								<input type="radio" id="releaseTo" value=2 name="radioInline" v-model="noticeInfo.recordType">
								<label for="releaseTo">只限本企业</label>
							</div>
						</div>
						<div class="form-group">
							<div class="radio radio-success radio-inline">
								<input type="radio" id="releaseTo1" value=3 name="radioInline" v-model="noticeInfo.recordType">
								<label for="releaseTo1">手工指定下发企业</label>
							</div>
						</div>
						<div class="form-group" v-show="noticeInfo.recordType==3">
							<ul id="company-tree" class="ztree"></ul>
						</div>
					</div>
				</div>
				<!--企业树部分结束-->
				<!--编辑部分开始-->
				<div class="col-sm-9">
					<div class="ibox-content">
						<div class="form-group">
							<label class="col-sm-12  control-label t_left">公告内容</label>
						</div>
						<div class="form-group">
							<textarea class="form-control" rows="15" :class="{red:importance==='紧急'}" v-model="noticeInfo.content" maxlength="5000"></textarea>
						</div>
						<div class="form-group" style="text-align: center;">
							<button v-if="permission.indexOf('noticeRelease_temporary') == -1" class="btn btn-primary" @click="saveTemporary" :disabled="!validDates">暂存</button>
							<button v-if="permission.indexOf('noticeRelease_issued') == -1" class="btn btn-primary" @click="releaseNotice" :disabled="!validDates">下发</button>
						</div>
					</div>
				</div>
				<!--编辑部分结束-->
				<tab-modal ref="modal1" size="small" :scroll='scrollTop' title="提示" v-on:cancel="confirm">
					{{messageStr}}
					<div slot="footer">
						<button @click="confirm" class="btn btn-primary">确定</button>
					</div>
				</tab-modal>
			</div>
		</div>
	</div>
</template>
<script>
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	import TabModal from 'components/common/TabModal'
	import { comMixin } from 'util/util.js'
	import { OPERATE_EXCEPTION, OPERATE_SUCCESS, SAVE_ENSURE } from 'static/message'
	import { DICTIONARY_MAP } from 'static/constant'
	import { getDictionaryFromArray } from 'util/util'
	import classlist from 'util/classlist'
	export default {
		name: 'PageNoticeRelease',
		mixins: [comMixin],
		components: {
			TabModal
		},
		data() {
			return {
				permission: this.$store.state.permission.permission["noticeRelease"] ? this.$store.state.permission.permission["noticeRelease"] : [],
				loadingstatus: false,
				picked: '', //单选值
				selected: false, //复选框
				importance: '普通', //下拉选项值，默认紧急程度为普通
				messageStr: "", // 弹出框提示内容
				scrollTop: '0',
				noticeInfo: {
					id: 0, //id  0为默认值
					title: '', //标题
					source: '1', //来源
					content: '', //多行文本框内容
					status: 1, //重要度
					recordType: 1, //下发范围
					customerListArray: [], //企业列表
					send_state: ""
				},
				orgTree: [], //组织机构树
				curDate: '', //当前时间日期  没啥用的东西		
				statusList: [], //紧急度 下拉数据		          
				//用到的字典
				udcType: [
					DICTIONARY_MAP.STATUS
				],
				setting: { //zTree基本配置-setting
					data: {
						simpleData: {
							enable: true
						}
					},
					check: {
						enable: true,
						chkboxType: { "Y": "", "N": "" },
						autoCheckTrigger: true
					},
					view: {
						showIcon: true
					},
					callback: {
						onCheck: null
					}
				},

			}

		},
		beforeMount() {
			//获取后台数据
			this.getTemporaryNotice();
		},

		created() {
			if(this.$store.state.user.admin == 9)
				this.noticeInfo.source = 0;
			else this.noticeInfo.source = 1;
		},
		computed: {
			//	起止时间是否合法
			validDates: function() {
				if(this.noticeInfo.title && this.noticeInfo.content) {
					return true;
				} else {
					return false;
				}
			}
		},
		mounted() {
			this.treeInit()
			this.getDate()
			this.getUdc();
			this.getOrgTree();
		},
		methods: {
			resetInfo() {
				this.noticeInfo.id = 0;
				this.noticeInfo.title = '';
				this.noticeInfo.content = '';
				this.noticeInfo.status = 1;
				this.noticeInfo.recordType = 1;
				this.noticeInfo.customerListArray = [];
				this.noticeInfo.send_state = '';
//				for(let i = 0; i < this.orgTree.length; i++) {
//					this.orgTree[i].checked = false;
//				}
				this.getOrgTree();

			},
			treeInit() {
				this.setting.callback.onCheck = this.onChecked;
				$.fn.zTree.init($("#company-tree"), this.setting, this.orgTree);
			},
			getDate() { //获取时间
				const date = new Date();
				this.curDate = this.stringify(date);
			},
			//获取暂存的公告
			getTemporaryNotice() {
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + '/notice/ntcs/state')
					.then(res => {
						var tmp = res.data.data;
						if(tmp == null) {
							this.loadingstatus = false;
							this.resetInfo();
							return;
						}
						this.noticeInfo = tmp;
						this.loadingstatus = false;
					})
			},
			getUdc() {
				if(this.udcType.length == 0) return;
				let param = this.udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs', { params: { udcTypes: param } })
					.then(res => {
						if(res.data.success) {
							this.getTemporaryNotice();
							this.statusList = getDictionaryFromArray(res.data.data, DICTIONARY_MAP.STATUS);
						}
					})
			},
			//获取组织树
			getOrgTree() {
				this.$http.get(process.env.API_ROOT + '/account/customer-tree/notice')
					.then(res => {
						var orgTreeTmp = res.data.data;
						this.orgTree = orgTreeTmp;
						orgTreeTmp.map(item => {
							item.open = true;
							return item;
						});
						if(this.noticeInfo.customerListArray.length != 0) {
							for(let i = 0; i < orgTreeTmp.length; i++) {
								for(let j = 0; j < this.noticeInfo.customerListArray.length; j++) {
									if(orgTreeTmp[i].id == this.noticeInfo.customerListArray[j]) {
										orgTreeTmp[i].checked = true;
										break;
									}
								}
							}
						}
						this.treeInit();
					})
			},
			onChecked(e, treeId, treeNode) {
				//取消选中后删除止
				var self = this;
				if(!treeNode.checked) {
					$.each(self.noticeInfo.customerListArray, function(index, item) {
						if(item == treeNode.id)
							self.noticeInfo.customerListArray.splice(index, 1);
					});
				} else {
					this.noticeInfo.customerListArray.push(treeNode.id);
				}

			},
			//更新公告
			updateNotice(sendState) {
				this.loadingstatus = true;
				this.noticeInfo.sendState = sendState;
				if(this.noticeInfo.recordType == 1 || this.noticeInfo.recordType == 2) {
					this.noticeInfo.customerListArray = [];
				}
				this.$http.put(process.env.API_ROOT + '/notice/ntcs/' + this.noticeInfo.id, this.noticeInfo)
					.then(res => {
						if(res.data.success) {
							this.openModal1(OPERATE_SUCCESS);
							this.getTemporaryNotice();
							//this.resetInfo();
						} else {
							this.openModal1(res.body.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.openModal1(res.body.message);
						this.loadingstatus = false;
					}).catch(res => {
						this.openModal1(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
			},
			//创建新公告
			createNotice(sendState) {
				this.loadingstatus = true;
				this.noticeInfo.sendState = sendState;
				if(this.noticeInfo.recordType == 1 || this.noticeInfo.recordType == 2) {
					this.noticeInfo.customerListArray = [];
				}
				this.$http.post(process.env.API_ROOT + '/notice/ntcs/', this.noticeInfo)
					.then(res => {
						if(res.data.success) {
							this.openModal1(OPERATE_SUCCESS);
							this.loadingstatus = false;
							this.getTemporaryNotice();
							//this.resetInfo();
						} else {
							this.openModal1(res.body.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.openModal1(res.body.message);
						this.loadingstatus = false;
					}).catch(res => {
						this.openModal1(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
			},
			//点击暂存公告
			saveTemporary() {
				if(this.noticeInfo.id == 0)
					this.createNotice(0);
				else
					this.updateNotice(0);
			},
			//点击下发
			releaseNotice() {
				if(this.noticeInfo.id == 0)
					this.createNotice(1);
				else
					this.updateNotice(1);
			},
			// 消息弹出框相关 ==============================
			openModal(ref) {
				this.$refs[ref].open();
				classlist.toggleScroll('close', '#notice-release', this);
			},
			closeModal(ref) {
				this.$refs[ref].close();
				classlist.toggleScroll('open', '#notice-release', this);
			},
			openModal1(message) {
				this.messageStr = message;
				this.openModal("modal1")
			},
			confirm() {
				this.closeModal("modal1");
				// 通知父组件刷新数据
				this.$emit("callback", "new-success");
			}
		}
	}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// PageNoticeRelease.vue?f802fee8